import { Button } from '@cdl/heartbeat-react';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Portal } from '../../../../shared/components/Portal';
import { ecgIdSelector } from '../../../ecg/selectors/ecg.selectors';
import { useNavigationRef } from '../../hooks/useNavigationRef';

export const NavigateMergeButton: React.FC = () => {
  const navigate = useNavigate();
  const navigationRef = useNavigationRef();
  const ecgId = useSelector(ecgIdSelector);
  const navigateMerge = useCallback(() => {
    if (ecgId == null) {
      return;
    }
    navigate(`/${ecgId}/clustering/merge`);
  }, [ecgId, navigate]);

  return (
    <Portal to={navigationRef}>
      <Button
        data-testid='navigate-merge-btn'
        onClick={navigateMerge}
        size='xs'
        borderRightRadius={0}
      >
        Merge
      </Button>
    </Portal>
  );
};
